// Google Ads tag, gated by cookie consent (Consent Mode v2). The "denied" defaults are set inline in public/index.html.
export const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "AW-18540589966";

const CONSENT_KEY = "jatak_cookie_consent";
const LANDING_KEY = "jatak_ad_landing";
const AD_PARAMS = ["gclid", "gbraid", "wbraid", "dclid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const PUBLIC = [/^\/$/, /^\/priser\/?$/, /^\/funktioner\/?$/, /^\/signup\/?$/, /^\/support\/?$/, /^\/guide(\/|$)/,
  /^\/privatliv\/?$/, /^\/vilkaar\/?$/, /^\/databehandleraftale\/?$/, /^\/sletning-af-data(\/|$)/];

let loaded = false;
let granted = false;

// gtag.js only accepts real `arguments` objects (not arrays)
const gtag = function () {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
};

export const isAdsRoute = (path) => PUBLIC.some((rx) => rx.test(path));

export function marketingConsent() {
  try {
    return !!JSON.parse(localStorage.getItem(CONSENT_KEY) || "null")?.prefs?.marketing;
  } catch {
    return false;
  }
}

// Keep gclid/UTM from the landing URL, so they survive SPA navigation until consent is given.
export function rememberLanding() {
  try {
    const q = new URLSearchParams(window.location.search);
    const keep = AD_PARAMS.filter((k) => q.get(k)).map((k) => [k, q.get(k)]);
    if (keep.length) sessionStorage.setItem(LANDING_KEY, new URLSearchParams(keep).toString());
  } catch {}
}

function landingLocation() {
  let saved = "";
  try {
    saved = sessionStorage.getItem(LANDING_KEY) || "";
  } catch {}
  if (!saved || window.location.search.includes("gclid=")) return window.location.href;
  const u = new URL(window.location.href);
  new URLSearchParams(saved).forEach((v, k) => !u.searchParams.has(k) && u.searchParams.set(k, v));
  return u.toString();
}

function clearGoogleCookies() {
  const host = window.location.hostname;
  const domains = ["", host, "." + host, "." + host.split(".").slice(-2).join(".")];
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("_gcl")).forEach((n) =>
    domains.forEach((d) => { document.cookie = `${n}=; Max-Age=0; path=/${d ? "; domain=" + d : ""}`; })
  );
}

// Call on every route change and whenever the cookie choice changes.
export function syncAds(path) {
  const allow = isAdsRoute(path) && marketingConsent();
  if (allow && !granted) {
    gtag("consent", "update", { ad_storage: "granted", ad_user_data: "granted", ad_personalization: "granted" });
    granted = true;
    if (!loaded) {
      loaded = true;
      gtag("js", new Date());
      gtag("config", ADS_ID, { page_location: landingLocation() });
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ADS_ID)}`;
      s.dataset.testid = "google-ads-tag";
      document.head.appendChild(s);
    }
  } else if (!allow && granted) {
    gtag("consent", "update", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
    granted = false;
    if (!marketingConsent()) clearGoogleCookies();
  }
}
